/**
 * IMPORTANT
 *
 * If you're updating any values in this file make sure to update the same values
 * in the 'typography.less' file as well.
 *
 * Both files should be sharing exactly same style properties.
 */
import createTypography from '@mui/material/styles/createTypography';
import { palette } from '../Palette';
export const TYPOGRAPHY_COMMON_STYLES = {
    WebkitFontSmoothing: 'antialiased',
};
export const TYPOGRAPHY_MUI_VARIANTS = {
    h1: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { fontWeight: 700, fontSize: '36px', letterSpacing: '-0.24px', lineHeight: '44px' }),
    h2: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { fontWeight: 700, fontSize: '28px', letterSpacing: '-0.24px', lineHeight: '36px' }),
    h3: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { fontWeight: 600, fontSize: '24px', letterSpacing: '-0.06px', lineHeight: '32px' }),
    h4: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { fontWeight: 600, fontSize: '20px', letterSpacing: '-0.06px', lineHeight: '28px' }),
    h5: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { fontWeight: 600, fontSize: '16px', letterSpacing: '-0.06px', lineHeight: '24px' }),
    subtitle1: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { fontWeight: 600, fontSize: '14px', letterSpacing: 'normal', lineHeight: '24px' }),
    subtitle2: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { fontWeight: 600, fontSize: '13px', letterSpacing: 'normal', lineHeight: '16px' }),
    body1: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { fontWeight: 400, fontSize: '16px', letterSpacing: 'normal', lineHeight: '24px' }),
    body2: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { fontWeight: 400, fontSize: '14px', letterSpacing: 'normal', lineHeight: '20px' }),
};
/**
 * Branch DSM custom variants.
 */
export const TYPOGRAPHY_DSM_CUSTOM_VARIANTS = {
    body3: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { fontWeight: 400, fontSize: '13px', letterSpacing: 'normal', lineHeight: '16px' }),
    titleBody: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { fontWeight: 400, fontSize: '20px', letterSpacing: '-0.05px', lineHeight: '28px' }),
    helpText: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { fontWeight: 400, fontSize: '13px', letterSpacing: 'normal', lineHeight: '16px' }),
    label: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { fontWeight: 600, fontSize: '12px', letterSpacing: 'normal', lineHeight: '16px', textTransform: 'uppercase' }),
};
/**
 * Default MUI styles - not part of the Branch DSM - do not use.
 * Those definitions are kept for a backwards compatibility.
 * @deprecated
 */
export const TYPOGRAPHY_MUI_DEPRECATED_VARIANTS = {
    /**
     * @deprecated
     */
    h6: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { fontWeight: 600, fontSize: '14px', letterSpacing: '-0.06px', lineHeight: '20px' }),
    /**
     * @deprecated
     */
    caption: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { color: palette.text.secondary, fontWeight: 400, fontSize: '11px', letterSpacing: 'normal', lineHeight: '13px' }),
    /**
     * @deprecated
     */
    overline: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { color: palette.text.secondary, fontWeight: 300, fontSize: '11px', letterSpacing: '0.33px', lineHeight: '13px' }),
    /**
     * @deprecated
     */
    button: Object.assign(Object.assign({}, TYPOGRAPHY_COMMON_STYLES), { color: palette.text.primary, fontSize: '14px' }),
};
export const TYPOGRAPHY_MUI_CONFIG = Object.assign(Object.assign({ fontFamily: 'Source Sans Pro, sans-serif', fontSize: 14, fontWeightLight: 300, fontWeightRegular: 400, fontWeightMedium: 500, fontWeightBold: 700 }, TYPOGRAPHY_MUI_VARIANTS), TYPOGRAPHY_MUI_DEPRECATED_VARIANTS);
export const typography = Object.assign(Object.assign({}, createTypography(palette, TYPOGRAPHY_MUI_CONFIG)), TYPOGRAPHY_DSM_CUSTOM_VARIANTS);
//# sourceMappingURL=Typography.constants.js.map